import * as React from 'react'

import { Box, Chevron, Popover, Text, useToggle } from '@factorialco/deprecated-design-system'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import TooltipHeader from 'modules/attendance/components/ClockIn/Tooltip/Header'
import TooltipRow from 'modules/attendance/components/ClockIn/Tooltip/Row'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { getTotalMinutes } from 'modules/attendance/lib/workedBreaksSummary'
import type Period from 'modules/attendance/store/models/Period'

type SizeType = React.ComponentProps<typeof Text>['size']
type WeightType = React.ComponentProps<typeof Text>['weight']

type WorkedBreak = {
  minutes: number
  trackedMinutes: number
}
export interface Props {
  period: Period
  workedBreaks: WorkedBreak[]
  size?: SizeType
  weight?: WeightType
  children?: React.ReactNode
  hasOvertimeAuthorization: boolean
  requestedOvertimeHours: number
}

export const WorkedHours = ({
  period,
  workedBreaks,
  size,
  weight,
  children,
  hasOvertimeAuthorization,
  requestedOvertimeHours,
}: Props) => {
  const [open, toggle] = useToggle(false)
  const overtimeMinutes = Math.ceil(requestedOvertimeHours * 60)
  const { worked_minutes, tracked_minutes } = period.attributes

  const totalMinutes = getTotalMinutes(workedBreaks)
  const hasPaidBreaksFeature = hasFeature('time_tracking_paid_breaks')

  return (
    <>
      <Popover.ItemList attachment="bottom center" toggle={toggle} open={open} gapDivider={false}>
        <Box inline flexDirection="row" gap="s8" alignItems="center">
          <MinutesToText value={worked_minutes} size={size} weight={weight} />
          <Chevron direction={open ? 'up' : 'down'} type="terciary" />
        </Box>
        <TooltipHeader title={i18n.t('time_tracking.worked.title')} minutes={worked_minutes} />
        <TooltipRow label={i18n.t('time_tracking.worked.effective')} value={worked_minutes} />
        <TooltipRow label={i18n.t('time_tracking.worked.tracked')} value={tracked_minutes} />
        {hasPaidBreaksFeature && (
          <TooltipRow label={i18n.t('time_tracking.worked.paid_breaks')} value={totalMinutes} />
        )}
        {hasOvertimeAuthorization && (
          <TooltipRow
            label={i18n.t('time_tracking.worked.approved_overtime')}
            value={overtimeMinutes}
          />
        )}
      </Popover.ItemList>
      {children}
    </>
  )
}
